import React from 'react'
import { Link } from 'react-router-dom'
import { CauseImage } from '../..'

export default function Causes() {
    return (
        <section className="causes-section pt-100 pb-70">
        <div className="container">
            <div className="section-title">
                <span>
                    <i className="flaticon-ribbon"></i>
                    Our Causes
                </span>
                <h2>The causes we care about</h2>
                <p>
                Child Hope holds a few key causes close at heart. Some of them include;
                </p>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-6">
                    <div className="single-causes">
                    <CauseImage title="Shelter" image="/assets/img/causes/1.jpg"/>
                       <div className="icon">
                            <i className="flaticon-book"></i>
                        </div>
                        <div className="causes-content">
                            <span>#Shelter</span>
                            <h3>Home for orphans</h3>
                            <p>
                            This facility will host every program, so it will have language classes, board meeting rooms, offices bedrooms, study/computer room, dining room, a kitchen and storage rooms. 
                            </p>
                            <div className="causes-progress-bar">
                                <div className="causes-progress-content">
                                    <span>Raised $5000.00</span>
                                    <div className="text-right">
                                        <span>Goal $8000.00</span>
                                    </div>
                                </div>
                                <p>
                                    Raised by 60 people before 14 days
                                </p>
                            </div>
                            <Link to="/causes/oiuhehvgv"  className="causes-btn-one">
                                Donate now
                                <i className="flaticon-right"></i>

                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-causes">
                        <CauseImage title="Feeding" image="/assets/img/causes/2.jpg"/>

                        <div className="icon">
                            <i className="flaticon-laptop"></i>
                        </div>
                        <div className="causes-content">
                            <span>#Feeding</span>
                            <h3>Eradicate malnutrition</h3>
                            <p>
                            A tangible feeding program is needed for the children that will be living at the facility. Three meals will be provided daily in accordance to the national food guide.
                            </p>
                            <div className="causes-progress-bar">
                                <div className="causes-progress-content">
                                    <span>Raised $4000.00</span>
                                    <div className="text-right">
                                        <span>Goal $8000.00</span>
                                    </div>
                                </div>
                                <p>
                                    Raised by 40 people before 12 days
                                </p>
                            </div>
                            <Link to="/causes/oiuhehvgv"  className="causes-btn-one">
                                Donate now
                                <i className="flaticon-right"></i>

                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-causes">
                        <CauseImage title="Health Care" image="/assets/img/causes/3.jpg"/>

                        <div className="icon">
                            <i className="flaticon-blood-bag"></i>
                        </div>
                        <div className="causes-content">
                            <span>#Health Care</span>
                            <h3>Health care service </h3>
                            <p>
                            This will help the persons responsible for the well-being of the children to treat, record and follow-up on illness that are within their scope of practice.
                            </p>
                            <div className="causes-progress-bar">
                                <div className="causes-progress-content">
                                    <span>Raised $1000.00</span>
                                    <div className="text-right">
                                        <span>Goal $5000.00</span>
                                    </div>
                                </div>
                                <p>
                                    Raised by 50 people before 20 days
                                </p>
                            </div>
                            <Link to="/causes/oiuhehvgv"  className="causes-btn-one">
                                Donate now
                                <i className="flaticon-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}
